import React from 'react'
import {Col, Row, Button} from 'reactstrap'
import SquareIcon from 'react-icons/lib/fa/square'
import TeamIcon from 'react-icons/lib/fa/group'
import FieldIcon from 'react-icons/lib/fa/map-pin'
import RefreshIcon from 'react-icons/lib/fa/refresh'

import {
    SUBS_PLAN_EXPIRE, FREE_SUBS_PLAN_EXPIRE_SUPPORT, ASSIGN_PLAN_CONTROLLER, FREE_SUBS_PLAN_EXPIRE_CUSTOMER
} from '../../constants'

let ControllerTabHeader = ({user, controller, field, modem_model, teamName,currentdate,subsEndDate, onRequestDataButtonClick, requestDataLoading, requestButtonText, is_expired, is_trial, is_paid, selectPayment, toggle, no_subscription}) =>
  <Row className="table-head text-left p-4">
        <Col xs={12} md={'auto'} className="d-inline-block order-1 align-baseline ellipsize">
            <div className="controllerName d-flex" title={controller.userIdentifiableName}>
                <h2 className="text-left font-weight-bold ellipsize d-inline-block align-baseline col-12 m-0 p-0">
                <SquareIcon className="light-sf-blue"/>
                <span className="d-inline d-sm-none d-md-inline d-lg-inline d-xl-none ellipsize">
                    {controller.titularName}
                </span>
                <span className="d-none d-sm-inline d-md-none d-lg-none d-xl-inline ellipsize">
                    {controller.userIdentifiableName}
                </span>
                </h2>
            </div>
        </Col>
        {field ?
            <Col xs={12} md={6} className="d-inline-block order-2 align-baseline ellipsize mt-1">
                    <p className="text-left ellipsize d-inline-block align-text-top m-0 p-0 col-12" title={`Field #${field.field_number} ${field.name}`}>
                        <FieldIcon className="mr-2 light-sf-blue"/>
                        Field&nbsp;#{field.field_number}&ensp;{field.name}
                    </p>
            </Col>:
                null}
       
        <Col xs={12} md={6} className="d-inline-block order-3 order-md-4 align-baseline ellipsize">
            {user && (user.isSupport || user.isDealer) && teamName ?
                <small className="text-left font-weight-bold ellipsize align-text-top d-inline-block mb-2 mt-2 mb-md-0 mt-md-1" title={teamName}>
                    <TeamIcon className='mr-2 light-sf-blue'/>{teamName}
                </small>:
                null}
        </Col>
        {modem_model == 3 ?
               <Col xs={12} className="d-block order-5 m-5 align-content-center text-center justify-content-center">
                  <h5> 
                   This unit could experience a termination of cell coverage due to Verizon’s phasing out of their 3G service as soon as 12/31/2020.<br></br> 
                    Please contact your SureFire representative at 785-626-3670 to schedule a return to upgrade the Cellular Modem in <br></br>your controller. 
               </h5>
            </Col>:
                null} 
        {/* check the condition for subscription tab
         if current date is greater than end date or plan is expired
         then show renew button
        */}
        {user.isSupport && (is_expired ||currentdate>subsEndDate) && is_paid && controller && !controller.archived ?
            <Col xs={12} className="d-block order-5 m_5 align-content-center text-center justify-content-center">
                <h3 class="headingText">{SUBS_PLAN_EXPIRE}<br /><br />
                    <Button className="renew_button" onClick={toggle}>
                        <span className="renew_button_span">Renew Subscription Plan</span></Button>
                </h3>           
            </Col> :
            user.isSupport && ((is_expired && is_trial) || (!is_expired && !is_trial && !is_paid)) && controller && !controller.archived ?
                <Col xs={12} className="align-content-center text-center justify-content-center">
                    <h3>
                        Free Trial has expired, please select subscription plan.<br/><br/>
                        <Button className="renew_button" onClick={toggle}>
                            <span className="renew_button_span">Renew Subscription Plan</span></Button>
                    </h3>

                </Col> :
                is_expired && is_trial && controller && !controller.archived ?
                    <Col xs={12} className="d-block order-5 m-5 align-content-center text-center justify-content-center">
                        <h3>
                            Free Trial has expired, please purchase a subscription plan.<br/><br/>
                            <Button onClick={()=>{console.log("toggle from inside tab header"); selectPayment()}}>Purchase Subscription Plan</Button>
                        </h3>
                    </Col> :
                    (is_expired || currentdate>subsEndDate)&& is_paid && controller && !controller.archived ?
                        <Col xs={12} className="d-block order-5 m-5 align-content-center text-center justify-content-center">
                            <h3>{SUBS_PLAN_EXPIRE}<br /><br />
                                <Button onClick={()=>{console.log("toggle from inside tab header"); selectPayment()}}>Renew Subscription Plan</Button>
                            </h3>
                        </Col> :
                    is_paid && currentdate>subsEndDate?
                        <Col xs={12} md={6} className="d-inline-block text-left order-4 order-md-3 align-baseline">
                        <Button onClick={onRequestDataButtonClick} className="bg-light-sf-orange ml-0 ml-md-5 mr-2">
                            <RefreshIcon className={`${requestDataLoading ? "spin" : ""} mr-2`}/>
                            {requestButtonText}
                        </Button>
                    
                        <Button className="renew_button" onClick={toggle}>
                            <span className="renew_button_span">Upgrade to Paid Subscription Plan</span></Button>
                        </Col> :
                    is_trial && controller && !controller.archived && user.isSupport ?
                                <Col xs={12} md={6} className="d-inline-block text-left order-4 order-md-3 align-baseline">
                                    <Button onClick={onRequestDataButtonClick} className="bg-light-sf-orange ml-0 ml-md-5 mr-2">
                                        <RefreshIcon className={`${requestDataLoading ? "spin" : ""} mr-2`}/>
                                        {requestButtonText}
                                    </Button>
                                 
                                    <Button className="renew_button" onClick={toggle}>
                                        <span className="renew_button_span">Upgrade to Paid Subscription Plan</span></Button>
                                </Col> :
                                    is_trial && controller && !controller.archived ?
                                        <Col xs={12} md={6} className="d-inline-block text-left order-4 order-md-3 align-baseline">
                                            <Button onClick={onRequestDataButtonClick} className="bg-light-sf-orange ml-0 ml-md-5 mr-2">
                                                <RefreshIcon className={`${requestDataLoading ? "spin" : ""} mr-2`}/>
                                                {requestButtonText}
                                            </Button>
                                            <Button onClick={()=>{console.log("toggle from inside tab header"); selectPayment()}}>Purchase Subscription Plan</Button>
                                        </Col> :
                                            controller.online && !controller.archived ?
                                                <Col xs={12} md={6} className="d-inline-block text-left order-4 order-md-3 align-baseline">
                                                    <Button onClick={onRequestDataButtonClick} className="bg-light-sf-orange ml-0 ml-md-5 col-12 col-md-8 col-lg-6">
                                                        <RefreshIcon className={`${requestDataLoading ? "spin" : ""} mr-2`}/>
                                                        {requestButtonText}
                                                    </Button>
                                                </Col> :
                                                    null}
    </Row>

export default ControllerTabHeader



// WEBPACK FOOTER //
// ./src/components/ui/ControllerTabHeader.js